<template>
  <div class="lr-tree-content" :style="'width:' + width + ';height:' + height">
    <div class="lr-tree">
      <div v-if="title" class="lr-tree-title">{{ title }}</div>
      <template v-if="filter">
        <lr-input
          v-if="selectFilter"
          class="lr-tree-input"
          :itemOptions="itemOptions"
          v-model="filterText"
          v-show="openWidth != '20px'"
        />
        <el-input
          v-else
          class="lr-tree-input"
          placeholder="输入关键字进行过滤"
          v-model="filterText"
          v-show="openWidth != '20px'"
        >
        </el-input>
      </template>
      <!-- <el-select v-model="filterText" class="lr-tree-input" filterable placeholder="选择进行过滤">
              <el-option
              v-for="item in filterOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
              </el-option>
          </el-select> -->
      <!--  -->
      <el-tree
        class="filter-tree"
        :data="data"
        :props="defaultProps"
        default-expand-all
        v-loading="loading"
        :filter-node-method="filterNode"
        @node-click="nodeClick"
        :node-key="nodeKey"
        highlight-current
        :ref="bindRef"
        :expand-on-click-node="false"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <i
            :class="
              'icon ' +
              (node.isLeaf
                ? 'icon-biaoqian'
                : node.expanded
                ? 'icon-dakai1'
                : 'icon-wenjiandai')
            "
          ></i>
          {{ node.label }}
        </span>
      </el-tree>
    </div>
    <div class="close-panel-icon" v-if="showCloseIcon" @click="toggleMenu()">
      <i
        :class="{
          'el-icon-caret-right': this.openWidth == '20px',
          'el-icon-caret-left': this.openWidth == '200px',
        }"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "lrTree",
  props: {
    filter: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    defaultProps: {
      type: Object,
      default: function () {
        return {
          children: "children",
          label: "label",
        };
      },
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    itemOptions: {
      type: Object,
      default: () => {},
    },
    selectFilter: {
      type: Boolean,
      default: false,
    },
    bindRef: {
      type: String,
      default: "tree",
    },
    nodeKey: {
      type: String,
      default: "ID",
    },

    filterSelf: {
      type: Boolean,
      default: false,
    },

    selectID: {
      type: String,
      default: "",
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed:{
    showCloseIcon(){
      return this.$listeners["setTreeWidth"]
    }
  },
  data() {
    return {
      filterText: "",
      openWidth: "200px",
    };
  },
  watch: {
    filterText(val) {
      if (this.filterSelf) this.$refs.tree.filter(val);
      else {
        if (this.filterText) {
          this.$emit("update:selectID", this.filterText);
          this.$emit("loadData");
        }
      }
    },
    selectID() {
      if (this.selectID !== this.filterText) {
        this.filterText = this.selectID;
      }
    },
  },
  mounted() {},
  methods: {
    toggleMenu() {
      this.openWidth = this.openWidth == "200px" ? "20px" : "200px";
      this.$emit("setTreeWidth", this.openWidth);
    },
    nodeClick(obj, node, component) {
      this.$emit("nodeClick", { obj, node, component });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    setCurrentKey(key) {
      this.$refs[this.bindRef].setCurrentKey(key);
    },
  },
};
</script>
<style scoped  lang="scss">
.lr-tree-content {
  padding-right: 20px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  overflow-x: hidden;
  position: relative;
  margin: 0 6px 0 0;
  height: 100%;
}

.lr-tree-content .close-panel-icon {
  position: absolute;
  right: 4px;
  top: 0;
  height: 50px;
  background: #409EFF;
  color: #fff;
  line-height: 50px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  font-size: 16px;

}

.lr-tree-content .lr-tree {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #ddd;
}

.lr-tree-content .lr-tree-input {
  margin-bottom: 10px;
}

.lr-tree-content .lr-tree-title {
  text-indent: 9px;
  border-left: 5px solid #409EFF;
  margin-bottom: 8px;
  padding: 7px;
  font-size: 18px;
  white-space: nowrap;
}

.lr-tree-content .lr-tree .el-select, .lr-tree-content .lr-tree .el-input {
  width: 98%;
}

.lr-tree-content .lr-tree-input {
  width: 100%;
}

.lr-tree-content .lr-tree .el-tree {
  font-size: 14px;
  overflow: auto;
}

.lr-tree-content .lr-tree .el-tree .el-tree--highlight-current
.el-tree-node.is-current
> .el-tree-node__content {
  background-color: #ccdeff;
}
</style>



// WEBPACK FOOTER //
// src/components/LrTree/index.vue